import React from 'react';
import styles from './styles.module.scss';
import { formatCurrency } from '@wolffun/system-currency';
import classnames from 'classnames';
import icValid from 'assets/svg/ic_valid.svg';
import icInfo from 'assets/svg/ic_info_outlined_V2.svg';
import icInvalid from 'assets/svg/ic_invalid.svg';
import Tooltip from 'src/Components/Tooltip';
import { TooltipPosition } from 'src/Components/Tooltip/types';
import icArrowDown from 'assets/svg/ic_arrow_down_fill.svg';
import classNames from 'classnames';
import { Breakpoint, useBreakpoint } from 'src/utils/breakpoints';

const SelectionInfo = ({
  numberSelected,
  totalPrice,
  thgBalance,
  isInvalidPrice
}) => {
  const breakpoint = useBreakpoint();
  const [collapsed, setCollapsed] = React.useState(false);
  React.useEffect(() => {
    if (breakpoint !== Breakpoint.PHONE) setCollapsed(false);else setCollapsed(true);
  }, [breakpoint]);

  const renderTooltipHeroes = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.tooltip, styles.tooltipHeroes)
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.describe
    }, "Staking 100 THG requires 1 NFT Hero"), /*#__PURE__*/React.createElement("span", {
      className: styles.example
    }, "Ex: If you stake 10,000 THG, you need 100 NFT heroes"), /*#__PURE__*/React.createElement("div", {
      className: styles.note
    }, /*#__PURE__*/React.createElement("span", null, "Once NFT heroes are staked, they will be removed from your inventory permanently")));
  };

  const renderTooltipPrivateTicket = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.tooltip, styles.tooltipPrivateTicket)
    }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Private tickets are used to join Private Sale."), /*#__PURE__*/React.createElement("li", null, "12-month staking generates 30% more Private Tickets compared to 6-month.")));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, breakpoint === Breakpoint.PHONE && /*#__PURE__*/React.createElement("img", {
    src: icArrowDown,
    onClick: () => setCollapsed(!collapsed),
    className: classNames(styles.icArrow, collapsed && styles.collapsed)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Heroes Selected")), /*#__PURE__*/React.createElement("div", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("span", null, numberSelected, " Heroes"))), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.row, styles.stakedInfo)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Stakable Amount")), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.value, isInvalidPrice ? styles.invalid : styles.valid)
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("img", {
    src: isInvalidPrice ? icInvalid : icValid,
    className: styles.icCheck
  }), formatCurrency(totalPrice, {
    withCurrency: true,
    trimWholeFraction: true
  }), /*#__PURE__*/React.createElement(Tooltip, {
    content: renderTooltipHeroes(),
    position: TooltipPosition.BOTTOM,
    color: "#2B23A9"
  }, /*#__PURE__*/React.createElement("img", {
    src: icInfo,
    className: styles.icInfo
  }))))), isInvalidPrice && /*#__PURE__*/React.createElement("span", {
    className: styles.message
  }, "Not enough THG. Please select fewer NFT heroes or get more THG"), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.moreInfo, collapsed && styles.collapsed)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Your Balance")), /*#__PURE__*/React.createElement("div", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("span", null, thgBalance && formatCurrency(thgBalance, {
    withCurrency: true,
    trimWholeFraction: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.row, styles.ptInfo)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Private Ticket")), /*#__PURE__*/React.createElement("div", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.normal
  }, "Tickets to be generated over time"), /*#__PURE__*/React.createElement(Tooltip, {
    content: renderTooltipPrivateTicket(),
    position: TooltipPosition.BOTTOM,
    color: "#2B23A9"
  }, /*#__PURE__*/React.createElement("img", {
    src: icInfo,
    className: styles.icInfo
  }))))));
};

export default SelectionInfo;